import { Heading, TextProps } from '@chakra-ui/react';

interface ReceiptHeaderProps extends TextProps {
  children: string;
}

export default function ReceiptHeader({
  children,
  ...props
}: ReceiptHeaderProps) {
  return (
    <Heading
      as="h2"
      fontSize="16px"
      lineHeight="105.556%"
      fontWeight={700}
      mb="22px"
      {...props}
    >
      {children}
    </Heading>
  );
}
